import { FetchError, Modal } from "components/molecules";
import { Button, Typography } from "components/atoms";
import { useUpdateEventMutation } from "services/studyPlanner";
import "./validate-modal.scss";

interface IProps {
  isOpen: boolean;
  handleOnclose: (isReset: boolean) => void;
  payload: any;
  theme: "light" | "dark";
  performUpdate: (eventId: any, newDate: any) => void;
  newDay: any;
  cardInfo: any;
  IsLoadingUpdateEvent?: boolean;
  openBottom?: boolean;
}

export const ValidateModal = ({
  isOpen,
  handleOnclose,
  payload,
  theme,
  performUpdate,
  cardInfo,
  newDay,
  IsLoadingUpdateEvent,
}: IProps) => {
  const deriveStatus = (status: any) => {
    if (status === 500 || status === "Error") return "Error";
    else return "Warning";
  };

  const modifyMessage = (msg: any): string => {
    if (msg && typeof msg === "string") {
      if (msg.toLowerCase().indexOf("before") > 0) {
        const parts = msg.split("before");
        return `${parts[0]} <span class="custom-text">before</span> ${parts[1]}`;
      } else if (msg.toLowerCase().indexOf("after") > 0) {
        const parts = msg.split("after");
        return `${parts[0]} <span class="custom-text">after</span> ${parts[1]}`;
      } else {
        return msg;
      }
    }
    return "";
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => handleOnclose(true)}
      theme={theme}
      style="validate-modal-custom-style"
    >
      {payload ? (
        <>
          <div className="validate-modal-header-wrapper">
            <Typography
              variant="h8Med"
              label={deriveStatus(payload.Status)}
              styles="validate-modal-header-text"
            />
          </div>
          <div className="validate-modal-body-wrapper">
            <Typography
              variant="h8Book"
              label={modifyMessage(payload.Message)}
              styles="message-text-custom-style"
            />
            {/* {isError ? <FetchError content="Oops! failed to load resources" /> : null} */}
            <div className="validate-modal-button-wrapper">
              {payload.Status === 500 || payload.Status === "Error" ? (
                <Button
                  icon={false}
                  type="score"
                  label="Okay"
                  onClick={() => handleOnclose(true)}
                />
              ) : (
                <>
                  <Button
                    icon={false}
                    type="online"
                    label="Cancel"
                    onClick={() => handleOnclose(true)}
                  />
                  <Button
                    icon={false}
                    type="score"
                    label="Continue"
                    onClick={() =>
                      performUpdate(cardInfo.StudyPlannerEventId, newDay)
                    }
                    isLoading={IsLoadingUpdateEvent}
                  />
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </Modal>
  );
};
